(function () {
  var UNIT_KEY = 'mn_sg_unit';
  var ALIASES = {
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL',
    XXL: 'XXL',
    '2XL': 'XXL',
    XXXL: '3XL',
    '3XL': '3XL'
  };
  var FIT = {
    S: 'Closest to 36" bust · 34" waist · 38" hips. Size up if you want more ease through the kameez.',
    M: 'Closest to 38" bust · 36" waist · 40" hips. The most common true-to-size starting point.',
    L: 'Closest to 40" bust · 38" waist · 42" hips. Size up if you prefer a relaxed festive drape.',
    XL: 'Closest to 42" bust · 40" waist · 44" hips. Keep XL if the bust matches; size up only for extra ease.',
    XXL: 'Closest to 44" bust · 42" waist · 46" hips. Check hip as well as bust before you decide.',
    '3XL': 'Closest to 46" bust · 44" waist · 48" hips. If you sit between XXL and 3XL, choose 3XL.'
  };

  function root() {
    return document.querySelector('.mn-sg[data-mn-sg]');
  }

  function stripLegacy() {
    document.querySelectorAll('[id="sizeGuidePopup"]').forEach(function (el) {
      if (!el.classList.contains('mn-sg')) el.remove();
    });
  }

  function normalizeSize(value) {
    if (!value) return '';
    var raw = String(value).trim().toUpperCase().replace(/\s+/g, '');
    if (ALIASES[raw]) return ALIASES[raw];
    var match = raw.match(/^(XXXL|XXL|3XL|2XL|XL|S|M|L)/);
    if (!match) return '';
    return ALIASES[match[1]] || match[1];
  }

  function selectedLabel() {
    var sizeField = document.querySelector(
      '.mn-sg-option [data-selected-value], variant-picker [data-option-name*="ize" i]'
    );
    var fromPicker = sizeField && sizeField.getAttribute('data-selected-value');
    var fromLabel = document.querySelector('.mn-sg-option .option-label--selected');
    var modal = root();
    return (
      (fromPicker && fromPicker.trim()) ||
      (fromLabel && fromLabel.textContent.trim()) ||
      (modal && modal.getAttribute('data-selected-size')) ||
      ''
    );
  }

  function highlight() {
    var modal = root();
    if (!modal) return;
    var size = normalizeSize(selectedLabel());
    modal.querySelectorAll('[data-mn-sg-size]').forEach(function (row) {
      row.classList.toggle('is-current', !!size && row.getAttribute('data-mn-sg-size') === size);
    });
    var pick = modal.querySelector('[data-mn-sg-pick]');
    if (!pick) return;
    if (size && FIT[size]) {
      var label = selectedLabel().replace(/[&<>"']/g, '');
      pick.hidden = false;
      pick.innerHTML = '<strong>Your selected size · ' + label + '</strong>' + FIT[size];
    } else {
      pick.hidden = true;
      pick.textContent = '';
    }
  }

  function applyUnit(unit) {
    var modal = root();
    if (!modal) return;
    unit = unit === 'cm' ? 'cm' : 'in';
    modal.querySelectorAll('[data-mn-sg-unit]').forEach(function (btn) {
      var on = btn.getAttribute('data-mn-sg-unit') === unit;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-in][data-cm]').forEach(function (cell) {
      cell.textContent = cell.getAttribute('data-' + unit);
    });
    try {
      window.sessionStorage.setItem(UNIT_KEY, unit);
    } catch (e) {}
  }

  function hoist(el) {
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
    return el;
  }

  function openGuide(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    stripLegacy();
    var modal = hoist(root());
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.style.setProperty('display', 'flex', 'important');
    document.documentElement.classList.add('mn-modal-open');
    highlight();
  }

  function closeGuide() {
    var modal = root();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.setProperty('display', 'none', 'important');
    if (!document.querySelector('.share-popup-overlay.is-open')) {
      document.documentElement.classList.remove('mn-modal-open');
    }
  }

  function isOpenTrigger(el) {
    return !!(el && el.closest && el.closest('[data-mn-open-size], [data-open-sizeguide], #open-size-guide, #mn-open-size-guide, .mn-sg-open, .mn-sizechart-link'));
  }

  function bindModal() {
    var modal = root();
    if (!modal || modal.dataset.mnSgBound === '1') return;
    modal.dataset.mnSgBound = '1';
    hoist(modal);
    modal.addEventListener('click', function (e) {
      var unit = e.target.closest('[data-mn-sg-unit]');
      if (unit) {
        e.preventDefault();
        applyUnit(unit.getAttribute('data-mn-sg-unit'));
      }
    });
  }

  function bindButtons() {
    document.querySelectorAll('[data-mn-open-size], [data-open-sizeguide], #open-size-guide, .mn-sg-open, .mn-sizechart-link').forEach(function (el) {
      if (el.dataset.mnSgClick === '1') return;
      el.dataset.mnSgClick = '1';
      el.addEventListener('click', openGuide);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t) return;
      if (isOpenTrigger(t)) {
        openGuide(e);
        return;
      }
      if (t.closest && t.closest('[data-mn-sg-close], #closeSizeGuide')) {
        closeGuide();
        return;
      }
      if (t.classList && t.classList.contains('mn-sg') && t.id === 'sizeGuidePopup') closeGuide();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeGuide();
  });

  document.addEventListener('variant:changed', function () {
    bindButtons();
    highlight();
  });

  document.addEventListener('quick-view:loaded', function () {
    bindButtons();
    highlight();
  });

  window.mnOpenSizeGuide = openGuide;

  function init() {
    stripLegacy();
    bindModal();
    bindButtons();
    highlight();
    var saved = 'in';
    try {
      saved = window.sessionStorage.getItem(UNIT_KEY) || 'in';
    } catch (e) {}
    applyUnit(saved);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
